"use client";

import {
  ConsentBanner,
  ConsentDialog,
  ConsentManagerProvider,
  type InitialDataPromise,
} from "@c15t/nextjs";
import type { ReactNode } from "react";
import {
  C15T_BROWSER_BACKEND_URL,
  C15T_CONSENT_CATEGORIES,
  C15T_CONSENT_DIALOG_DESCRIPTION,
  C15T_MEASUREMENT_DESCRIPTION,
  C15T_STORAGE_KEY,
} from "./consent.config";

export interface ConsentProviderProps {
  children: ReactNode;
  cookieDomain?: string;
  storageKey?: string;
  ssrData?: InitialDataPromise;
}

type ConsentComponent = (props?: Record<string, never>) => ReactNode;

const TypedConsentBanner = ConsentBanner as unknown as ConsentComponent;
const TypedConsentDialog = ConsentDialog as unknown as ConsentComponent;

export function ConsentProvider({
  children,
  cookieDomain,
  storageKey = C15T_STORAGE_KEY,
  ssrData,
}: ConsentProviderProps) {
  return (
    <ConsentManagerProvider
      options={{
        mode: "hosted",
        backendURL: C15T_BROWSER_BACKEND_URL,
        consentCategories: [...C15T_CONSENT_CATEGORIES],
        i18n: {
          locale: "en",
          messages: {
            en: {
              cookieBanner: { description: C15T_MEASUREMENT_DESCRIPTION },
              consentManagerDialog: { description: C15T_CONSENT_DIALOG_DESCRIPTION },
              consentTypes: {
                measurement: { description: C15T_MEASUREMENT_DESCRIPTION },
              },
            },
          },
        },
        ssrData,
        storageConfig: {
          defaultDomain: cookieDomain,
          storageKey,
        },
      }}
    >
      <TypedConsentBanner />
      <TypedConsentDialog />
      {children}
    </ConsentManagerProvider>
  );
}
